var utils = (function( $ ) {

	/*
	 * Returns the viewport size, including scrollbars - which matches media queries
	 *
	 * http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
	 */
	var viewport_size = function() {
		var e = window, a = 'inner';
		if ( !( 'innerWidth' in window ) ) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width: e[a + 'Width'], height: e[a + 'Height'] };
	};

	// Function from David Walsh: http://davidwalsh.name/css-animation-callback
	var which_transition_event = function() {
		var t, el = document.createElement( "fakeelement" );

		var transitions = {
			"transition": "transitionend",
			"OTransition": "oTransitionEnd",
			"MozTransition": "transitionend",
			"WebkitTransition": "webkitTransitionEnd"
		};

		for ( t in transitions ) {
			if ( el.style[t] !== undefined ) {
				return transitions[t];
			}
		}
	};

	var is_in_view = function ( $elem ) {
		var element_top    = $elem.offset().top,
			element_bottom = element_top + $elem.outerHeight(),
			viewport_top = $( window ).scrollTop(),
			viewport_bottom = viewport_top + $(window).height();

		return element_bottom > viewport_top && element_top < viewport_bottom;
	};

	return {
		viewport_size: viewport_size,
		which_transition_event: which_transition_event,
		is_in_view: is_in_view
	};

})( jQuery );

module.exports = utils;